// extracted by mini-css-extract-plugin
module.exports = {"layout":"Container_layout__v5y1X","cards":"Container_cards__9B82j","badge":"Container_badge__pKK0J"};